import type { Site } from '~/types/Site'

export const useStructuredLodgingBusiness = (site?: Site) => {
  const route = useRoute()

  if (site) {
    useHead({
      script: [
        {
          type: 'application/ld+json',
          innerHTML: {
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'LodgingBusiness',
                name: site.name,
                latitude: site.latitude,
                longitude: site.longitude,
                description: site.seo?.description,
                image: site.images[0]?.small,
                areaServed: site.meta.area.name,
                address: site.address,
                telephone: site.phone,
                url: route.fullPath,
                aggregateRating: site.reviews && {
                  '@type': 'aggregateRating',
                  ratingCount: site.reviews?.reviewCount,
                  reviewCount: site.reviews?.reviewCount,
                  bestRating: 10,
                  ratingValue: site.reviews?.averageScore,
                },
              },
            ],
          },
        },
      ],
    })
  }
}
